import { styled } from 'baseui'

export const OuterContainer = styled('div', ({ $theme }) => ({
  padding: '1rem',
  marginBottom: '2rem',
  color: $theme.colors.white,
}))

export const Block = styled('div', ({ $theme }) => ({
  padding: '1rem',
  marginTop: '2rem',
  marginBottom: '2rem',
  backgroundColor: $theme.colors.white,
  borderRadius: '1rem',
  boxShadow: $theme.lighting.shadowPrimary,
  width: '100%',
  color: $theme.colors.contentSecondary,
}))
